import { render, staticRenderFns } from "./BaseAddButton.vue?vue&type=template&id=0d9f7926&"
import script from "./BaseAddButton.vue?vue&type=script&lang=js&"
export * from "./BaseAddButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports